import styles from './style.module.css'
const Label = ({ labelText, className }) => {
    return (
        <>
            <label className={`${styles.label} ${className}`}>{labelText}</label>
        </>
    )
}
export default Label